<ion-item id="invoices" data-cy="" (click)="actionClick()">
  <ion-label [attr.data-cy]="'payments-tile-title-' + getDataCyAttr(title)">{{
    title
  }}</ion-label>
  <div class="item-badge">
    <ion-badge
      *ngIf="badgeText !== undefined"
      color="danger"
      mode="ios"
      data-cy="unpaid-text"
    >
      {{ badgeText }}
    </ion-badge>
  </div>
  <ion-icon
    color="primary"
    name="chevron-forward-outline"
    slot="end"
    [attr.data-cy]="'expand-mobile-tile-btn-' + getDataCyAttr(title)"
  ></ion-icon>
</ion-item>
